<template lang="pug">
form.sv-upload-doc
    label.sv-upload-doc__wrapper
        SvButton.sv-upload-doc__button(
            view="bordered"
            text="Загрузить"
        )

        input.sv-upload-doc__input(
            ref="doc"
            name="price_list"
            type="file"
            @change="uploaded"
        )

        .sv-upload-doc__title
            SvIcon.sv-upload-doc__icon(
                icon="attach"
            )

            span.sv-upload-doc__text
              | {{ title }}
</template>

<script>
import SvIcon from '@/components/uikit/SvIcon.vue';
import SvButton from '@/components/uikit/SvButton.vue';

export default {
  name: 'SvUploadDoc',

  components: {
    SvButton,
    SvIcon,
  },

  data() {
    return {
      doc: null,
      title: 'Файл не выбран',
    };
  },

  props: {
    value: {
      type: Object,
      default: null,
    },

    uploadUrl: {
      type: String,
      default: '/admin/residentials/upload-price-list'
    }
  },

  methods: {
    async uploaded(e) {
      this.title = e.target.files[0].name;
      this.$emit('input', e.target.files[0]);
      const form = new FormData();
      form.append('price_list', e.target.files[0]);
      await this.$store.dispatch('residential/uploadPrice', form);
    },
  },
};
</script>

<style lang="scss" scoped>
.sv-upload-doc {
  &__wrapper {
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
  }

  &__button {
    width: 140px;
  }

  &__input {
    width: 100%;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  &__title {
    margin-left: 10px;
    display: flex;
    align-items: center;
  }

  &__text {
    color: #ADB2C0;
    font-size: 14px;
    line-height: 19px;
    font-weight: 500;
    margin-left: 8px;
  }
}
</style>
